export const validateNewPassword = (password) => {
  if (!password || password.length < 8) {
    return "Password must be at least 8 characters.";
  }

  let combinations = 0;

  if (/[a-z]/.test(password)) combinations++;
  if (/[A-Z]/.test(password)) combinations++;
  if (/[0-9]/.test(password)) combinations++;
  if (/[^a-zA-Z0-9]/.test(password)) combinations++;

  if (combinations < 3) {
    return "Password must include at least 3 of: uppercase, lowercase, numbers, and special characters.";
  }

  return "";
};
